import queryKeys from './queryKeys';
import queryHelper from './queryHelper';
import validateRedirectUrl from './validateRedirectUrl';

const updateUrlWithOpenPush = (value) => {
  queryHelper.updateQueryWithValues({
    [queryKeys.activeFactPush]: value,
  });
};
const updateUrlWithOpenTilePush = (value) => {
  queryHelper.updateQueryWithValues({
    [queryKeys.activeTilePush]: value,
  });
};

const updateUrlWithOpenHotelSectionPush = (value) => {
  queryHelper.updateQueryWithValues({
    [queryKeys.activeHotelSectionPush]: value,
  });
};

const getOpenHotelSectionPush = () => {
  return queryHelper.getQueryKeyValue(queryKeys.activeHotelSectionPush);
};

const getOpenHotelSection = () => {
  return queryHelper.getQueryKeyValue(queryKeys.activeHotelSection);
};

const updateUrlWithOpenHotelSection = (selectedSection) => {
  let sectionQueryValue = selectedSection;
  if (selectedSection === 'overview') {
    // Due to SEO, do not set section query param for default section (overview)
    sectionQueryValue = undefined;
  }

  queryHelper.updateQueryWithValues({
    [queryKeys.activeHotelSection]: sectionQueryValue,
  });
};

export {
  updateUrlWithOpenPush,
  updateUrlWithOpenTilePush,
  updateUrlWithOpenHotelSectionPush,
  getOpenHotelSectionPush,
  queryKeys,
  queryHelper,
  validateRedirectUrl,
  getOpenHotelSection,
  updateUrlWithOpenHotelSection,
};
